import { createFileRoute, Link } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { ButtonLink } from '@interxfi/design-system/components/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { RaglManualEntriesTable } from '../../../../../../../../../features/clearing-ledger/manual-entry/ragl-manual-entries-table';
import { RAGL_MANUAL_ENTRY_BASE_PATH } from '../../../../../../../../../features/clearing-ledger/manual-entry/ragl-manual-entry-routing';
import { getPageHead } from '../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry/')({
  head: () => getPageHead('Manual Entries'),
  component: ClearingManualEntryList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
      <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
        <RequiresAccess write>
          <ButtonLink
            affixIcon={<PlusIcon aria-hidden />}
            aria-label="Create a Journal Entry"
            LinkElement={Link}
            size="small"
            to={`${RAGL_MANUAL_ENTRY_BASE_PATH}/create`}
            variant="primary"
          />
        </RequiresAccess>
        {filter}
      </HorizontalStack>
    </HorizontalStack>
  );
}

function ClearingManualEntryList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <RaglManualEntriesTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
